import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IrisIconModule } from '@sondermind/iris/icon';

import { IrisIconButtonComponent } from './icon-button.component';

@NgModule({
  declarations: [
    IrisIconButtonComponent
  ],
  imports: [
    CommonModule,
    IrisIconModule
  ],
  exports: [
    IrisIconButtonComponent
  ]
})
export class IrisIconButtonModule { }
